import Vue from 'vue';
import VueRouter from 'vue-router';
import Home from '../views/Home.vue';
import {getCurrentUser, login} from "../api/login";
import {getSiteIdByDhSiteInfo} from "@/api/grzx"

Vue.use(VueRouter);
//获取原型对象上的push函数
const originalPush = VueRouter.prototype.push
//修改原型对象中的push方法
VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}
const props = (route) => Object.assign({}, route.query, route.params);
const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home,
    redirect: '/FirstHome',
    meta: { title: '首页' },
    children: [
      {
        path: 'FirstHome',
        name: 'FirstHome',
        meta: { title: '首页' },
        component: () => import('@/views/childViews/FirstHomeYes'),
        props
      },
      {
        path: 'NoLoginFirstHome',
        name: 'NoLoginFirstHome',
        meta: { title: '首页' },
        component: () => import('@/views/childViews/FirstHome'),
        props
      },
      {
        path: '/OnlineConsultation',
        name: 'OnlineConsultation',
        meta: { title: '在线咨询' },
        component: () => import('@/views/OnlineConsult/index'),
        redirect: '/OnlineConsultation/OnlineCult',
        children: [
          {
            path: 'OnlineCult',
            name: 'OnlineCult',
            meta: { title: '咨询申请' },
            component: () => import('@/views/OnlineConsult/OnlineCult'),
            props
          },
          {
            path: '/OnlineConsultation/HistoryCult',
            name: 'HistoryCult',
            meta: { title: '历史咨询' },
            component: () => import('@/views/OnlineConsult/HistoryCult'),
            props
          },
          {
            path: '/OnlineConsultation/consultDetail',
            name: 'consultDetail',
            meta: { title: '咨询详情' },
            component: () => import('@/views/OnlineConsult/consultDetail'),
            props
          }
        ]
      },
      {
        path: 'LawyerArea',
        name: 'LawyerArea',
        meta: { title: '律师服务面对面' },
        component: () => import('@/views/LawyerService/LawyerArea'),
        props
      },
      {
        path: 'LawyerIndex',
        name: 'LawyerIndex',
        meta: { title: '律师服务面对面' },
        component: () => import('@/views/LawyerService/LawyerIndex'),
        redirect: '/LawyerArea',
        children: [
          {
            path: 'Lawyer',
            name: 'Lawyer',
            meta: { title: '律师' },
            component: () => import('@/views/LawyerService/Lawyer'),
            props
          },
          {
            path: 'LawyerDetail',
            name: 'LawyerDetail',
            meta: { title: '律师详情' },
            component: () => import('@/views/LawyerService/LawyerDetail'),
            props
          },
        ]
      },
      {
        path: '/LawyerAppoint',
        name: 'LawyerAppoint',
        meta: { title: '律师服务面对面' },
        component: () => import('@/views/LawyerService/LawyerAppoint/index'),
        redirect: '/LawyerAppoint/LAppoint',
        children: [
          {
            path: 'LAppoint',
            name: 'LAppoint',
            meta: { title: '律师预约' },
            component: () => import('@/views/LawyerService/LawyerAppoint/LAppoint'),
            props
          },
          {
            path: 'HistoryAppoint',
            name: 'HistoryAppoint',
            meta: { title: '历史预约' },
            component: () => import('@/views/LawyerService/LawyerAppoint/HistoryAppoint'),
            props
          }, {
            path: 'AppointDetail',
            name: 'AppointDetail',
            meta: { title: '预约详情' },
            component: () => import('@/views/LawyerService/LawyerAppoint/AppointDetail'),
            props
          }
        ]
      },
      {
        path: 'Aid',
        name: 'Aid',
        meta: { title: '法律援助' },
        component: () => import('@/views/LegalAid/Aid/index'),
        redirect: '/Aid/ApplicationGuide',
        children: [
          {
            path: 'ApplicationGuide',
            name: 'ApplicationGuide',
            meta: { title: '法援申请' },
            component: () => import('@/views/LegalAid/Aid/ApplicationGuide'),
            props
          },
          {
            path: 'HistoryAid',
            name: 'HistoryAid',
            meta: { title: '历史援助' },
            component: () => import('@/views/LegalAid/Aid/HistoryAid'),
            props
          },
          {
            path: 'LegalAid',
            name: 'LegalAid',
            meta: { title: '法律援助详情' },
            component: () => import('@/views/LegalAid/Aid/LegalAid'),
            props
          },
        ]
      },
      {
        path: 'LegalAidApply',
        name: 'LegalAidApply',
        meta: { title: '法律援助' },
        component: () => import('@/views/LegalAid/LegalAidApply'),
        props
      },
      {
        path: 'EpRightsProtection',
        name: 'EpRightsProtection',
        meta: { title: '法律法规' },
        component: () => import('@/views/SubHome'),
        redirect: "/EpRightsProtection",
        children: [
          {
            path: '',
            meta: { title: '法律法规' },
            component: () => import('@/views/EpRights/components/EpRightsProtection'),
            props,
          },
          {
            path: 'Regulations1',
            name: 'Regulations1',
            meta: { title: '详情' },
            component: () => import('@/views/EpRights/components/Regulations'),
            props
          },
        ]
      },
      {
        path: 'LawsRegulations',
        name: 'LawsRegulations',
        meta: { title: '职工维权问答' },
        component: () => import('@/views/SubHome'),
        redirect: "/LawsRegulations",
        children: [
          {
            path: '',
            meta: { title: '职工维权问答' },
            component: () => import('@/views/EpRights/components/LawsRegulations'),
          },
          {
            path: 'Regulations2',
            name: 'Regulations2',
            meta: { title: '详情' },
            component: () => import('@/views/EpRights/components/Regulations'),
            props
          },
        ]
      },
      {
        name: 'LegalPublicity',
        path: '/LegalPublicity',
        component: () => import('@/views/LegalPublicity/LegalPublicity'),
        meta: { title: '小圆小梦职场说法' },
      },
      {
        name: "LegalPublicityInfo",
        path: '/LegalPublicityInfo',
        component: () => import('@/views/LegalPublicity/LegalPublicityInfo'),
        meta: { title: '职场说法详情' }
      },
      {
        name: 'workplaceStatement', // 小圆小梦职场说法详情
        path: '/workplaceStatement',
        meta: { title: '维权案例' },
        component: () => import('@/views/LegalPublicity/workplaceStatement'),
      },
      {
        name: 'workplaceStatementInfo',
        path: '/workplaceStatementInfo',
        meta: { title: '维权案例' },
        component: () => import('@/views/LegalPublicity/workplaceStatementInfo'),
        props
      },
      {
        path: 'CaseBase',
        name: 'CaseBase',
        meta: { title: '案例库' },
        component: () => import('@/views/Case/CaseBase'),
        props
      },
      {
        path: 'CaseIndex',
        name: 'CaseIndex',
        meta: { title: '案例库' },
        component: () => import('@/views/Case'),
        props,
        children: [
          {
            path: 'CaseView',
            name: 'CaseView',
            meta: { title: '案例详情' },
            component: () => import('@/views/Case/CaseView'),
            props,
          }
        ]
      },
    ]
  },
  {
    path: '/about',
    name: 'About',
    component: () => import(/* webpackChunkName: "about" */ '../views/About.vue'),
  },
];

const router = new VueRouter({
  mode: 'history',
  base: process.env.VUE_APP_BASEROUTE,
  routes,
});


router.beforeEach((to, from, next) => {

  let sessionid = sessionStorage.getItem('sessionid');
  // let user = sessionStorage.getItem('user');

  if (from.query.webid) {
    getSiteIdByDhSiteInfo({ pcSiteId: from.query.webid }).then(res => {
      localStorage.setItem("webid", res.data.data)
    })
  }

  /* ------------------------ */


  // axios.get('http://www.jshghfw.com/yyczxt/head/verifylsLogin.do').then(response => {
  //   if (response) {
  //     console.log("response测试调用大汉是否登录得接口返回值", response)
  //     // if(response.success){//已登录
  //     //   if (to.query.ticket) {
  //     //     dologin(to, from, next);
  //     //   } else {
  //     //     getCurrentUser().then(res => {
  //     //       if (res && res.uuid) {
  //     //         sessionStorage.setItem('user', JSON.stringify(res))
  //     //         next();
  //     //       } else {
  //     //         sessionStorage.setItem('user', '')
  //     //         if (process.env.NODE_ENV === "development") {
  //     //           testdologin(to, from, next);
  //     //         } else {
  //     //           location.href = process.env.VUE_APP_LOGIN_URL
  //     //         }
  //     //         // //todo 跳转至大汉登录页
  //     //         // location.href="http://www.jsghfw.com/jis/front/login/auth.do?appmark=jsgh12351";
  //     //         // location.href = process.env.VUE_APP_LOGIN_URL
  //     //         // next();
  //     //         // alert("未登录");
  //     //         // dologin(to, from, next);
  //     //       }
  //     //     });
  //     //   }
  //     // }else{//未登录
  //     //   getCurrentUser().then(res => {
  //     //     if (to.query.ticket) {
  //     //       dologin(to, from, next);
  //     //     } else {
  //     //       if (res && res.uuid) {
  //     //         sessionStorage.setItem('user', JSON.stringify(res))
  //     //         next();
  //     //       } else {
  //     //         sessionStorage.setItem('user', '')
  //     //         if (process.env.NODE_ENV === "development") {
  //     //           testdologin(to, from, next);
  //     //         } else {
  //     //           next();
  //     //         }
  //     //       }
  //     //     }
  //     //   });
  //     // }
  //   }
  // }).catch(err => {
  //   console.log("err测试调用大汉是否登录得接口返回值", err)
  // })
  /* ------------------------ */
  if (to.path == '/NoLoginFirstHome') {
    sessionStorage.setItem('loginType', 'NoLoginFirstHome')
  }
  let loginType = sessionStorage.getItem('loginType')
  // sessionStorage.setItem("webid", "3201")
  // || loginType == 'NoLoginFirstHome'
  if (to.path !== '/FirstHome' ) {//免登录的方法（不是首页或存在免登录状态的）
    getCurrentUser().then(res => {
      if (to.query.ticket) {
        dologin(to, from, next);
      } else {
        if (res && res.uuid) {
          sessionStorage.setItem('user', JSON.stringify(res))
          next();
        } else {
          sessionStorage.setItem('user', '')
          if (process.env.NODE_ENV === "development") {
            testdologin(to, from, next);
          } else {
            next();
          }
        }
      }
    });
  } else if (to.path == '/FirstHome') {//正常登录的方法（是首页且已登录的调用）  && loginType !== 'NoLoginFirstHome'
    if (to.query.ticket) {
      dologin(to, from, next);
    } else {
      getCurrentUser().then(res => {
        if (res && res.uuid) {
          sessionStorage.setItem('user', JSON.stringify(res))
          next();
        } else {
          sessionStorage.setItem('user', '')
          if (process.env.NODE_ENV === "development") {
            testdologin(to, from, next);
          } else {
            location.href = process.env.VUE_APP_LOGIN_URL
          }
          // //todo 跳转至大汉登录页
          // location.href="http://www.jsghfw.com/jis/front/login/auth.do?appmark=jsgh12351";
          // location.href = process.env.VUE_APP_LOGIN_URL
          // next();
          // alert("未登录");
          // dologin(to, from, next);
        }
      });
    }
  }
})

const dologin = (to, from, next) => {
  login({ ticket: to.query.ticket }).then(res => {
    if (res && res.uuid) {
      sessionStorage.setItem("sessionid", res.sessionid);
      sessionStorage.setItem('loginType', '')//已登录清除免登录状态
      delete to.query.ticket;
      next(to);
      location.href = location.href.substring(0, location.href.indexOf("ticket"));
    } else {
      //todo 跳转至大汉登录页
      // alert("未登录");
      // next();
      location.href = "http://www.jsghfw.com/yyczxt/jis/jumptologin.do?nowUrl=https://tyzy.jsghfw.cn/jss_zgh_12351_pc_web&appmark=jsgh12351";
    }
  });
}


const testdologin = (to, from, next) => {
  const testuser = {
    "uuid": "123",
    "name": "用户1",
    "sex": "0",
    "mobile": "18322222222",
    "cardid": "320101199901010001",

  };
  login(testuser).then(res => {
    if (res.uuid) {
      const sessionid = res.sessionid;
      sessionStorage.setItem("sessionid", sessionid);
      // sessionStorage.setItem("user",JSON.stringify(user));
      // sessionStorage.setItem("sessionid",sessionid);
      delete to.query.ticket;
      next(to);
      return;
    } else {
      //todo 跳转至大汉登录页
      alert("未登录");
      // location.href = "https://www.jszwfw.gov.cn/jsjis/front/login.do?appMark=jszgfww&gotoUrl=aHR0cDovL3d3dy5qc2doZncuY29tLw==";
      next();
    }
  });
}

export default router;
